import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const BrandsRoutes: Routes = [
  {
    path: "brands",
    loadComponent: () =>
      import("./brands.component").then((m) => m.BrandsComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./brand-list/brand-list.component").then(
            (m) => m.BrandListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./brand-form/brand-form.component").then(
            (m) => m.BrandFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./brand-form/brand-form.component").then(
            (m) => m.BrandFormComponent,
          ),
      },
    ],
  },
];
